import axios from "axios";

import { store } from "./index";
import {
  addNotificationAC,
  logoutSagaAC,
} from "model/system/systemActionCreators";
import { getAccessToken, getRefreshToken } from "model/system/dSystemAPI";
import { getCookie } from "utils/utils";

// переменная для хранения запроса токена
let refreshTokenRequest: any = null;

const remoteMerchantId = getCookie("tindaRemoteMerchant");

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  // ошибки со статусом кода меньше 500 обрабатываем на фронте
  validateStatus: (status) => status < 500,

  headers: { Merchant: remoteMerchantId ? remoteMerchantId : undefined },
});

// запросить валидный аксесс токен
async function requestValidAccessToken() {
  let authData = localStorage.getItem("authData");
  let accessToken = getAccessToken();

  if (authData) {
    accessToken = JSON.parse(authData!).accessToken;
    // приводим текущее время к unix timestamp
    const now = Math.floor(Date.now() * 0.001);
    let authParsedData = authData ? JSON.parse(authData) : null;

    if (now >= authParsedData.expRefreshToken + 30) {
      // Если рефреш токен устарел, разлогиниваем пользователя
      store.dispatch(logoutSagaAC());
    } else if (now >= authParsedData.expAccessToken + 30) {
      // если не было запроса на обновление
      // создаем запрос и запоминаем его в переменную
      // для избежания race condition
      if (refreshTokenRequest === null) {
        refreshTokenRequest = getRefreshToken({
          refreshToken: authParsedData.refreshToken,
        }).then((res) => {
          if (res.status === 200) {
            const expAccessToken =
              Math.floor(Date.now() * 0.001) + res.data.expires_in;
            const expRefreshToken =
              Math.floor(Date.now() * 0.001) + res.data.refresh_expires_in;

            const toLocalData = {
              accessToken: res.data.access_token,
              refreshToken: res.data.refresh_token,
              expAccessToken: expAccessToken,
              expRefreshToken: expRefreshToken,
            };
            localStorage.setItem("authData", JSON.stringify(toLocalData));
            return res.data.access_token;
          }
          return res;
        });
      }
      accessToken = await refreshTokenRequest;
      // и очищаем переменную
      refreshTokenRequest = null;
    }
  }

  // возвращаем рабочий accessToken
  return accessToken;
}

export const getLanguage = () => {
  return store.getState().system.language;
};

// обрабатываем запрос перед отправкой
apiClient.interceptors.request.use(async (config) => {
  // если указан флаг skipAuth, пропускаем запрос дальше как есть
  // этот флаг указан у методов login и refreshToken, они не подкрепляются токенами
  // @ts-ignore
  if (config.skipAuth) {
    return {
      ...config,
      headers: {
        ...config.headers,
        "Accept-Language": getLanguage(),
      },
    };
  }

  // иначе запрашиваем валидный accessToken
  const accessTokenValid = await requestValidAccessToken();

  // и возвращаем пропатченный конфиг с токеном в заголовке
  return {
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${accessTokenValid}`,
      "Accept-Language": getLanguage(),
    },
  };
});

// обрабатываем запрос перед обработкой ответа от сервера
apiClient.interceptors.response.use(
  // сюда попадает все, что валидируется успешным ответом status < 500
  (response) => {
    // const {
    //     data: { errors },
    //     config: { skipErrors },
    //     status,
    // } = response;

    // если пришла 401, разлогиниваем пользователя
    if (response.status === 401) {
      store.dispatch(logoutSagaAC());
    } else if (response.status === 403) {
      const id = new Date();
      store.dispatch(
        addNotificationAC({
          id: id.getTime().toString(),
          message: "ERROR_ACCESS",
        }),
      );
    } // else if (errors && !skipErrors) {
    //     // показываем ошибки сервера для фронта, если нет указаний пропустить их вывод
    //     showErrors(errors);
    // }

    return response;
  },
  (error) => Promise.reject(error),
);

export { apiClient };
